import { getHeaders } from "./api"
import { handleGraphQlResp } from "../util/api_utils"
import { backendHost } from "../util/environment_utils"

export const sendGraphqlRequest = query => {
    return fetch(`${backendHost}/v1/graphql`, {
        method: "POST",
        headers: getHeaders({ "Content-Type": "application/json; charset=UTF-8" }),
        body: JSON.stringify({ query }),
    })
        .then(resp => {
            if (!resp.ok) {
                throw new Error(`Request failed with status code ${resp.status}`)
            }
            return resp.json()
        })
        .then(body => handleGraphQlResp(body))
        .catch(error => error)
}



// WEBPACK FOOTER //
// ./src/api/graphQlClient.js